import flagID from '../assets/svg/flag-id';
import flagEN from '../assets/svg/flag-en';

const LANGUAGES = [
  { label: "English", code: "en", icon: flagEN },
  { label: "Bahasa", code: "id", icon: flagID },
];


export {
  LANGUAGES
}